import get from 'lodash/get';

import {
  BASKET_SUMMARY_V3_REQUEST,
  BASKET_SUMMARY_V3_RESPONSE,
  BASKET_SUMMARY_V3_ERROR,
} from 'lib/constants/v3Actions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case BASKET_SUMMARY_V3_REQUEST:
      return {
        ...state,
        [action.params.menuSlug]: {
          ...state[action.params.menuSlug],
          isLoading: true,
          isLoaded: false,
        },
      };
    case BASKET_SUMMARY_V3_RESPONSE:
      return {
        ...state,
        [action.params.menuSlug]: {
          isLoading: false,
          isLoaded: true,
          isError: false,
        },
      };
    case BASKET_SUMMARY_V3_ERROR:
      return {
        ...state,
        [action.params.menuSlug]: {
          isLoading: false,
          isLoaded: false,
          isError: true,
        },
      };
    case 'LOGOUT':
      return initialState;
    default:
      return state;
  }
};

export const isError = (state, menuSlug) => get(state, [menuSlug, 'isError']) === true;

export const isLoaded = (state, menuSlug) => get(state, [menuSlug, 'isLoaded'], false);

export const isLoading = (state, menuSlug) => get(state, [menuSlug, 'isLoading'], false);
